<template>
  <div>
    <p class="h-4 ml-4 bg-shimmer rounded-md w-36 dark:bg-gray-850"></p>
    <div class="space-y-3 mt-2 px-4">
      <div
        v-for="n in 3"
        :key="`coupon-${n}`"
        class="h-20 border border-b-4 rounded-lg flex items-stretch"
      >
        <div
          class="w-20 border-r-2 border-dashed p-4 flex items-center justify-center flex-col"
        >
          <div class="bg-shimmer h-8 w-8 rounded-md dark:bg-gray-850"></div>
          <div
            class="bg-shimmer h-3 w-6 rounded-md mt-1 dark:bg-gray-850"
          ></div>
        </div>
        <div class="p-4 flex flex-col justify-center flex-grow">
          <div class="bg-shimmer h-5 w-24 rounded-md dark:bg-gray-850"></div>
          <div class="bg-shimmer h-px w-full mt-2 dark:bg-gray-850"></div>
          <div
            class="bg-shimmer h-3 w-full rounded-md mt-2 dark:bg-gray-850"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
